import "rxjs/add/operator/catch";
import "rxjs/add/operator/do";
import "rxjs/add/operator/map";

import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { APIConfigService } from "./api.config";
import { ResponseBody } from "./response-body";
import { DatePipe } from "@angular/common";
import { environment } from "src/environments/environment";
import { Observer } from "rxjs";
import { API } from "./end-points";
import { SharedService } from "../pages/Services/shared.service";
import { map } from "rxjs/operators";
@Injectable()
export class NetworkService {
	apiHost: any;
	basicApiHost: any;
	KEY_VAR: any;
	IV_VAR: any;
	userData: any;
	
	constructor(
		private apiService: APIConfigService,
		private http: HttpClient,
		private datepipe: DatePipe,
		private sharedServices: SharedService
	) {
		this.sharedServices.getConfig().subscribe((result) => {
			if (result) {
				this.apiHost = result["apiHost"];
				this.basicApiHost = result["basicApiHost"];
			}
		});
	}

	// GET /v1/model/1
	getById(id: number, apiEndPoint: string): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);

		const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.get<ResponseBody>(this.apiHost + "/" + apiEndPoint + "/" + id, {
				observe: "response",
				headers: headers,
			})
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				if (response.status == 204) {
					return null;
				}
			});
		// .catch(APIConfigService.handleError);
	}

	// POST /v1/model
	addModel(
		model: any,
		apiEndPoint: string,
		params?: HttpParams
	): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);
		const headers = this.apiService.getAcessTokenHeaders();

		return this.http
			.post<ResponseBody>(
				this.apiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
					params: params,
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				if (response.status == 204 && apiEndPoint === API.MENUITEMS.MENUITEM) {
					let temp: any = { menu: [], screenList: [] };
					//response.body=temp;
					return temp;
				}
				return response;
			});
		// .catch(APIConfigService.handleError);
	}

	// POST /v1/model
	addModelForTEXTResponse(
		model: any,
		apiEndPoint: string,
		params?: HttpParams
	): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);
		const headers = this.apiService.getAcessTokenHeadersForText();

		return this.http
			.post(this.apiHost + "/" + apiEndPoint, JSON.stringify(model), {
				headers: headers,
				params: params,
				responseType: "text",
			})
			.map((response) => {
				// if (response.status == 200) {
				//   return response.body;
				// }
				// if (response.status == 204 && apiEndPoint === API.MENUITEMS.MENUITEM) {
				//   let temp: any = { menu: [], screenList: [] };
				//   //response.body=temp;
				//   return temp;
				// }
				return response;
			});
		// .catch(APIConfigService.handleError);
	}

	delete(apiEndPoint: string): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);

		const headers = this.apiService.getAcessTokenHeaders();

		//new changes
		return this.http
			.delete(this.apiHost + "/" + apiEndPoint, {
				headers: headers,
				observe: "response",
				responseType: "text" as "json",
			})
			.map((response) => {
				if (response.status == 200) {
					if (!response.body) {
						return [];
					}
					return response.body;
				}
			});
	}

	// DELETE /v1/model/1
	deleteById(id: any, apiEndPoint: string): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);

		const headers = this.apiService.getAcessTokenHeaders();

		//new changes
		return this.http
			.delete(this.apiHost + "/" + apiEndPoint + "/" + id, {
				headers: headers,
				observe: "response",
				responseType: "text" as "json",
			})
			.map((response) => {
				if (response.status == 200) {
					if (!response.body) {
						return [];
					}
					return response.body;
				}
			});
		// return this.http
		//   .delete<ResponseBody>(
		//     this.apiHost + "/" + apiEndPoint + "/" + id,
		//     {
		//       headers: headers,
		//       observe: "response"
		//     }
		//   )
		//   .map(response => {
		//     if (response.status == 200) {
		//       if (!response.body) {
		//         return [];
		//       }
		//       return response.body;
		//     }
		//   });
	}

	deleteMappingRuleById(id: any, apiEndPoint: string, urlEndText?: string): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);

		const headers = this.apiService.getAcessTokenHeaders();
		//new changes
		let newUrlText = urlEndText ? urlEndText : '';
		return this.http
			.delete(this.apiHost + "/" + apiEndPoint + "/" + id + newUrlText, {
				headers: headers,
				observe: "response",
				responseType: "text" as "json",
			})
			.map((response) => {
				if (response.status == 200) {
					if (!response.body) {
						return [];
					}
					return response.body;
				}
			});
	}

	// DELETE /v2/model/1
	deleteMultipleById(model: any, apiEndPoint: string): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);

		const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.request<ResponseBody>("DELETE", this.apiHost + "/" + apiEndPoint, {
				headers: headers,
				body: JSON.stringify(model),
			})
			.map((response) => {
				console.log("delete response", response);
				if (response && response.status == 200) {
					return response.data;
				}
			});
		// .catch(APIConfigService.handleError);
	}

	deleteAppointmentById(model: any, apiEndPoint: string): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);

		const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.request<ResponseBody>("DELETE", this.apiHost + "/" + apiEndPoint, {
				headers: headers,
				body: JSON.stringify(model),
				observe: "response"
			})
			.map((response) => {
				console.log("delete response", response);
				if (response && response.status == 200) {
					return "true";
				} else {
					return "false";
				}
			});
		// .catch(APIConfigService.handleError);
	}

	// PUT /v1/model/1
	updateModel(
		model: any,
		apiEndPoint: string,
		password?: any
	): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);

		const headers = password
			? this.apiService.getAcessTokenHeaders().set("password", password)
			: this.apiService.getAcessTokenHeaders();
		return this.http
			.put<ResponseBody>(
				this.apiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				return response;
			});
		// .catch(APIConfigService.handleError);
	}

	// PUT /v1/model/1
	updateAccessTokenModel(model: any, apiEndPoint: string): Observable<any> {
		const headers = this.apiService.getAcessTokenHeaders();

		return this.http
			.put<ResponseBody>(
				this.apiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
			});
		// .catch(APIConfigService.handleError);
	}

	// GET /v1/model
	getAllListing(
		apiEndPoint: string,
		params?: HttpParams,
		fromAgreement?: boolean
	): Observable<any> {
		//const headers = this.apiService.getAcessTokenHeaders();
		let langId = APIConfigService.getLanguage()
			? APIConfigService.getLanguage().toString()
			: "1";
		//var apiEndPoint = apiEndPoint.replace("Microsoft", "W3Schools");
		const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.get<ResponseBody>(this.apiHost + "/" + apiEndPoint, {
				observe: "response",
				headers: headers,
				params: params,
			})
			.map((response) => {
				if (fromAgreement) {
					if (response.status == 200) {
						return response.body;
					} else {
						return null;
					}
				} else {
					if (response.status == 200) {
						return response.body;
					}
					if (response.status == 204 && !apiEndPoint.match(/coverages/g)) {
						return null;
					}
					if (response.status == 204 && apiEndPoint.match(/coverages/g)) {
						return response.status;
					}
				}
			});
	}

	// GET /v1/model with status
	getAllListingWithStatus(
		apiEndPoint: string,
		params?: HttpParams,
		fromAgreement?: boolean,
	): Observable<any> {
		//const headers = this.apiService.getAcessTokenHeaders();
		let langId = APIConfigService.getLanguage()
			? APIConfigService.getLanguage().toString()
			: "1";
		//var apiEndPoint = apiEndPoint.replace("Microsoft", "W3Schools");
		const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.get<ResponseBody>(this.apiHost + "/" + apiEndPoint, {
				observe: "response",
				headers: headers,
				params: params
			})
			.map((response) => {
				return response;
			});
	}

	getImage(imageUrl: string): Observable<Blob> {
		imageUrl = this.apiHost + "/" + imageUrl;
		//const headers = APIConfigService.getHeaders("");

		const headers = this.apiService.getAcessTokenHeaders();

		return this.http.get(imageUrl, { responseType: "blob", headers: headers });
	}

	getonlineapprovaltransactions(url: string): Observable<any> {
		const headers = this.apiService.getAcessTokenHeaders();

		return this.http.get(this.apiHost + "/" +url, { responseType: "json", headers: headers });
	}

	getExcelTemplateFile(apiEndPoint: string,
		params?: HttpParams,): Observable<any> {
		const headers = this.apiService.getAcessTokenHeaders();
		return this.http.get(this.apiHost + "/" + apiEndPoint, {
			responseType: "text",
			headers: headers,
			params: params,
		});
	}


	changeDateFormat(date) {
		return this.datepipe.transform(date, this.getShowDateFormat());
	}

	changeTimeFormat(date) {
		return this.datepipe.transform(date, this.getShowTimeFormat());
	}

	changeDateTimeFormat(date) {
		return this.datepipe.transform(date, this.getShowDateTimeFormat());
	}

	getShowDateFormat() {
		return environment.SHOW_DATE_FORMAT;
	}

	sendDateFormat(date) {
		return this.datepipe.transform(date, this.getSendDateFormat());
	}

	getSendDateFormat() {
		return environment.SEND_DATE_FORMAT;
	}

	getShowDateTimeFormat() {
		return environment.SHOW_DATE_TIME_FORMAT;
	}

	getShowTimeFormat() {
		return environment.SHOW_TIME_FORMAT;
	}

	//we are using separate post method for login due to basic authorization
	//login uses basic auth
	basicPost(model: any, apiEndPoint: string): Observable<any> {
		const headers = APIConfigService.getHeaders(apiEndPoint);
		// console.log(headers);
		//const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.post<ResponseBody>(
				this.basicApiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				return response;
			});
		// .catch(APIConfigService.handleError);
	}

	redirectAPI(model: any, apiEndPoint: string): Promise<any> {
		const headers = APIConfigService.getHeaders(apiEndPoint);
		// console.log(headers);
		//const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.post<ResponseBody>(
				this.basicApiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				return response;
			})
			.toPromise();
		// .catch(APIConfigService.handleError);
	}

	//we are using separate post method for login due to basic authorization
	//login uses basic auth
	basicPostApi(model: any, apiEndPoint: string): Observable<any> {
		const headers = APIConfigService.getHeaders(apiEndPoint);
		// console.log(headers);
		//const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.post<ResponseBody>(
				this.apiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				return response;
			});
		// .catch(APIConfigService.handleError);
	}

	//we are using separate put method for refresh due to basic authorization with put method
	//refresh token uses basic auth
	basicPut(model: any, apiEndPoint: string): Observable<any> {
		const headers = APIConfigService.getHeaders(apiEndPoint);
		//const headers = this.apiService.getAcessTokenHeaders();
		return this.http
			.put<ResponseBody>(
				this.basicApiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				return response;
			});
		// .catch(APIConfigService.handleError);
	}

	basicGetById(id: any, apiEndPoint: string): Observable<any> {
		const headers = APIConfigService.getHeaders(apiEndPoint);
		return this.http
			.get<ResponseBody>(this.basicApiHost + "/" + apiEndPoint + "/" + id, {
				observe: "response",
				headers: headers,
			})
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				if (response.status == 204) {
					return null;
				}
			});
		// .catch(APIConfigService.handleError);
	}

	basicGet(apiEndPoint: string): Observable<any> {
		const headers = APIConfigService.getHeaders(apiEndPoint);
		return this.http
			.get<ResponseBody>(this.apiHost + "/" + apiEndPoint, {
				observe: "response",
				headers: headers,
			})
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				if (response.status == 204) {
					return null;
				}
			});
		// .catch(APIConfigService.handleError);
	}

	getMenuApi(model: any, apiEndPoint: string): Promise<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);
		const headers = this.apiService.getAcessTokenHeaders();
		//console.log("Api has been called");
		return this.http
			.post(this.apiHost + "/" + apiEndPoint, JSON.stringify(model), {
				headers: headers,
				observe: "response",
			})
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				if (response.status == 204) {
					let temp: any = { menu: [], screenList: [] };
					//response.body=temp;
					return temp;
				}
				return response;
			})
			.toPromise();
		// .catch(APIConfigService.handleError);
	}

	getConfigurations(filename: string): Promise<any> {
		try {
			return this.http
				.get<any>("/assets/json/config/" + filename + ".json")
				.toPromise();
		} catch (ex) {
			return null;
		}
	}

	getDecryptedPassword(filename1: string, filename2: string): Promise<any> {
		try {
			return this.http
				.get<any>("/assets/json/config/" + filename2 + ".json")
				.toPromise()
				.then((configData) => {
					let confiObj = {
						//username: configData["EvoPortal"]["apiBasicUsername"],
						MODULE_ID: configData["EvoPortal"]["moduleId"],
						MODULE_NAME: configData["EvoPortal"]["moduleName"],
						RESET_PASS_CALLBACK_LINK:
							configData["EvoPortal"]["callBackLink"],
						basicApiHost: configData["EvoPortal"]["apiBasicUrl"],
						apiHost: configData["EvoPortal"]["apiUrl"],
						loginUrl: configData["EvoPortal"]["loginUrl"],
						confirmPricingScreen:
							configData["EvoPortal"]["confirmPricingScreen"],
						dateFormat: configData["EvoPortal"]["dateFormat"],
					};
					this.sharedServices.updateConfig(confiObj);
					return confiObj;
				});
		} catch (ex) {
			return null;
		}
	}

	// getDecryptedPassword(KEY_VAR:string, IV_VAR:string):Promise<any>{

	//   let key = CryptoJS.enc.Utf8.parse(environment.KEY_VAR);
	//           let iv = CryptoJS.enc.Utf8.parse(environment.IV_VAR);
	//           let decrypted = CryptoJS.AES.decrypt(value, key, {
	//               keySize: 128 / 16,
	//               iv: iv,
	//               mode: CryptoJS.mode.CBC,
	//               padding: CryptoJS.pad.Pkcs7
	//           });

	//   return decrypted.toString(CryptoJS.enc.Utf8);
	// }

	//   decrypt(value){
	//     let key = CryptoJS.enc.Utf8.parse(environment.KEY_VAR);
	//     let iv = CryptoJS.enc.Utf8.parse(environment.IV_VAR);
	//     let decrypted = CryptoJS.AES.decrypt(value, key, {
	//         keySize: 128 / 16,
	//         iv: iv,
	//         mode: CryptoJS.mode.CBC,
	//         padding: CryptoJS.pad.Pkcs7
	//     });

	//     return decrypted.toString(CryptoJS.enc.Utf8);
	//   }

	// POST /v1/model used in force change password
	addModelSpecial(model: any, apiEndPoint: string): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);
		//const headers = APIConfigService.getAcessTokenHeadersForceChangePassword();
		this.sharedServices
			.checkForceChangePassword()
			.subscribe((result) => (this.userData = result));
		let headers = new HttpHeaders();
		//let accessToken = JSON.parse(localStorage.getItem("currentUser"));
		headers = headers.set("Content-Type", "application/json");
		headers = headers.set("authorization", this.userData["accessToken"]);
		//headers = headers.set("authorization", accessToken.accessToken,);
		headers = headers.set("languageId", "1");
		return this.http
			.post<ResponseBody>(
				this.apiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				if (response.status == 204 && apiEndPoint === API.MENUITEMS.MENUITEM) {
					let temp: any = { menu: [], screenList: [] };
					//response.body=temp;
					return temp;
				}
				return response;
			});
		// .catch(APIConfigService.handleError);
	}

	adjudicatePost(model: any, apiEndPoint: string) {
		const headers = new HttpHeaders({
			"Content-Type": "application/json",
			languageId: "1",
			Authorization:
				"Basic dGF0c2hib3BvcnRhbF91c2VyOlRwYkxUSllXS2NCakM5aGdieWtr",
		});
		return this.http
			.post<ResponseBody>(
				this.apiHost + "/" + apiEndPoint,
				JSON.stringify(model),
				{
					headers: headers,
					observe: "response",
				}
			)
			.map((response) => {
				if (response.status == 200) {
					return response.body;
				}
				return response;
			});
	}

	getLanguages() {
		return this.http
			.get<any>("/assets/json/languages/languages.json")
			.toPromise();
	}

	uploadExcelTemplate(
		model: any,
		apiEndPoint: string,
		params?: HttpParams
	): Observable<any> {
		const headers = this.apiService.getAcessTokenHeadersForMultipartData();
		return this.http
			.post<any>(
				this.apiHost + "/" + apiEndPoint,
				model,
				{
					// headers: { 'Content-Type': 'multipart/form-data' },
					headers: headers,
					observe: "response",
					params: params,
				}
			)
			.map((response) => {
				// if (response.status == 200) {
				// 	return response.body;
				// }
				// if (response.status == 204 && apiEndPoint === API.MENUITEMS.MENUITEM) {
				// 	let temp: any = { menu: [], screenList: [] };
				// 	//response.body=temp;
				// 	return temp;
				// }
				// return response;
			});
		// .catch(APIConfigService.handleError);
	}


	uploadJsonTemplate(
		model: any,
		apiEndPoint: string,
		params?: HttpParams
	): Observable<any> {
		const headers = this.apiService.getAcessTokenHeadersForMultipartData();
		return this.http
			.post(
				this.apiHost + "/" + apiEndPoint,
				model,
				{
					// headers: { 'Content-Type': 'multipart/form-data' },
					headers: headers,
					observe: "response",
					params: params,
					responseType: "text"
				}
			)
			.map((response) => {

			});
	}

	// DELETE /v1/model/1
	deleteByUrl(apiEndPoint: string): Observable<any> {
		//const headers = APIConfigService.getHeaders(apiEndPoint);

		const headers = this.apiService.getAcessTokenHeaders();

		//new changes
		return this.http
			.delete(this.apiHost + "/" + apiEndPoint , {
				headers: headers,
				observe: "response",
				responseType: "text" as "json",
			})
			.map((response) => {
				if (response.status == 200) {
					if (!response.body) {
						return [];
					}
					return response.body;
				}
			});
		// return this.http
		//   .delete<ResponseBody>(
		//     this.apiHost + "/" + apiEndPoint + "/" + id,
		//     {
		//       headers: headers,
		//       observe: "response"
		//     }
		//   )
		//   .map(response => {
		//     if (response.status == 200) {
		//       if (!response.body) {
		//         return [];
		//       }
		//       return response.body;
		//     }
		//   });
	}



}
